import { Vector2 } from "./Utils";
export class GObject {
    constructor(props) {
        this.position = props.position || new Vector2(0, 0);
        this.dimensions = props.dimensions || new Vector2(0, 0);
        this.scale = props.scale || 1;
        this.rotation = props.rotation || 0;
        this.children = props.children;
        this.id = props.id;
        this.className = props.className;
    }
    render(ctx, parent) {
        if (this.sprite) {
            this.sprite.draw(ctx, this);
        }
    }
    ;
    build(game) {
        return this.children || [];
    }
}
//# sourceMappingURL=GObject.js.map